webModule.controller('ssoIntegrationController',
    ['$scope', '$location', 'erateSessionVarsService', 'identityMgmntService',
        'userAuthenticateService', 'imSessionVarsService', '$q', 'routes', 'ssoAuthenticationService',
        'DealerInfo', 'dealershipService', 'rolePermissionsService', 'commonTLCService', 'providerFeaturesService',
        'rateQuoteCoordService', 'TLCError', 'AppErrorCodes', 'quoteIntegrationService', 'vehicleDefinitionService',
        'usageEventsService',
        function ($scope, $location, erateSessionVarsService, identityMgmntService,
            userAuthenticateService, imSessionVarsService, $q, routes, ssoAuthenticationService,
            DealerInfo, dealershipService, rolePermissionsService, commonTLCService, providerFeaturesService,
            rateQuoteCoordService, TLCError, AppErrorCodes, quoteIntegrationService, vehicleDefinitionService, usageEventsService) {

            //
            // responsible for setting up the user and dealership from
            // an SSO request

            $scope.init = function () {

                var token = $location.search()['token'];
                var dealerId = $location.search()['dealerid'];

                //sso portal based on IM already
                var ssoImToken = $location.search()['imtk'];
                var ssoDlid = $location.search()['imdlr'];
                var ssoShCaseView = $location.search()['tlc'];

                if (ssoImToken) {
                    //issue with +'s url encoding
                    ssoImToken = ssoImToken.replace(' ','+');
                    userAndDealerSSOIm(ssoImToken, ssoDlid, ssoShCaseView);
                } else {
                    if (dealerId) {
                        userAndDealerSSO(token, dealerId);
                    } else {
                        userSSO(token);
                    }
                }
            }

            var userSSO = function (token) {
                var imProviderId = null;
                var imUserId = null;
                var showcaseIntroVal = null;

                //impersonate the "global authorized user" until we get the user's data
                identityMgmntService.getEngineeringToken()
                    .then(
                    function (engToken) {
                        //temporarily.. until we get the user, dealer, provider, etc.
                        userAuthenticateService.setUserToken(engToken);
                        //retrieve the SSO information
                        return ssoAuthenticationService.retrieveSSOUserInfo(token);
                    },
                    function (err) {
                        throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                    }
                    )
                    .then(
                    function (restRet) {
                        var integrationInfo = restRet.data;
                        //grab the fields
                        imProviderId = integrationInfo.imProviderId;
                        imUserId = integrationInfo.imUserId;
                        //set what we know so far
                        imSessionVarsService.setCurrentProviderId(imProviderId);
                        return providerFeaturesService.getProviderApplicationSetting('LogoutRedirectUrl', null);
                    },
                    function (err) {
                        throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                    }
                    )
                    .then(function (logoutUrl) {
                        erateSessionVarsService.setProviderLogoutUrl(logoutUrl);
                        return providerFeaturesService.getProviderApplicationSetting('ShowcaseLiteIntro', 'false');
                    })
                    .then(function (showcaseIntro) {
                        showcaseIntroVal = showcaseIntro;
                        //get the user by id
                        return identityMgmntService.getUserById(imUserId);
                    })
                    .then(
                    function (imUser) {
                        //set the user for the session

                        var promiseCalls = [];
                        //here is where we set the auth token to the TRUE user's identity::
                        var setupSSOUserP = ssoAuthenticationService.setupSSOUser(imUser);

                        usageEventsService.userChanges(imUser);

                        imSessionVarsService.setCurrentIMUser(imUser);
                        //provider
                        var getProviderP = identityMgmntService.getProviderByProviderId(imProviderId);
                        //roles
                        var getRolesP = rolePermissionsService.generateUserRoleRouteMap();

                        $q.all([setupSSOUserP, getProviderP, getRolesP])
                            .then(
                            function (promiseReturns) {
                                //aren't using [0] promise return

                                var imProvider = promiseReturns[1];
                                imSessionVarsService.setCurrentProviderCode(imProvider.ProviderCode);

                                imSessionVarsService.setCurrentIMUserRoles(imUser.Claims);

                                dealershipService.getUserDealerships(0,10)
                                    .then(
                                    function (responseDealerships) {
                                        if (responseDealerships.length === 1) {
                                            var dealerInfo = responseDealerships[0];
                                            try {
                                                usageEventsService.dealerChanges(dealerInfo.id);

                                                commonTLCService.setupEssentialDealerVars(dealerInfo)
                                                    .then(function () {
                                                        //clear out any "stale" state information
                                                        rateQuoteCoordService.startNewQuoteSession(true, true, true, true);
                                                        quoteIntegrationService.clearIntegrationData();
                                                        vehicleDefinitionService.vehicleDetailsData.ready = false;
                                                        if ((showcaseIntroVal || 'false').toUpperCase() == 'true')
                                                            $location.url(routes.showcaseLiteRedirect);
                                                        else
                                                            $location.url(routes.createQuote);
                                                    }),
                                                    function (err) {
                                                        throw new TLCError(err, AppErrorCodes.Global_Unknown);
                                                    }
                                            }
                                            catch (ex) {
                                                // This should not happen
                                                switch (ex) {
                                                    case "ACCOUNT-NOT-FOUND":
                                                        throw new TLCError(new Error('Could not find dealer account code for dealer: ' + dealerInfo.name), AppErrorCodes.Dealer_Not_Found, this);
                                                    case "SPANID-NOT-FOUND":
                                                        throw new TLCError(new Error('Could not find dealer SPAN id for  dealer: ' + dealerInfo.name), AppErrorCodes.Dealer_Not_Found, this);
                                                }
                                                throw new TLCError(ex, AppErrorCodes.Dealer_Not_Found);
                                            }
                                        }
                                        else if (responseDealerships.length > 1) {
                                            $location.path(routes.dealershipSearch);
                                        } else {
                                            //growl.error('You do not have access to any dealerships.');
                                            $location.path(routes.dealershipSearch);
                                        }
                                    },
                                    function (err) {
                                        throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                                    }
                                    );
                            })
                            .catch(function (err) {
                                throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                            });
                    },
                    function (err) {
                        throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                    }
                    );
            }

            var userAndDealerSSO = function (token, dealerId) {
                var imDealerId = null;
                var imProviderId = null;
                var imUserId = null;
                var spanDealerId = null;
                var showcaseIntroVal = null;

                //impersonate the "global authorized user" until we get the user's data
                userAuthenticateService.getEngineeringToken()
                    .then(
                    function (engToken) {
                        //temporarily.. until we get the user, dealer, provider, etc.
                        userAuthenticateService.setUserToken(engToken);
                        //retrieve the SSO information
                        return ssoAuthenticationService.retrieveSSOUserDealerInfo(token, dealerId);
                    },
                    function (err) {
                        throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                    }
                    )
                    .then(
                    function (integrationInfo) {
                        //grab the fields
                        imDealerId = integrationInfo.imDealerId;
                        imProviderId = integrationInfo.imProviderId;
                        imUserId = integrationInfo.imUserId;
                        spanDealerId = integrationInfo.spanDealerId;
                        //set what we know so far
                        return commonTLCService.encryptNumeric(integrationInfo.spanDealerId);
                    },
                    function (err) {
                        throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                    }
                    )
                    .then(function (encid) {
                        erateSessionVarsService.setCurrentDealerSPANId(encid);
                        imSessionVarsService.setCurrentProviderId(imProviderId);
                        imSessionVarsService.setCurrentDealerIMId(imDealerId);
                        return providerFeaturesService.getProviderApplicationSetting('LogoutRedirectUrl', null);
                    })
                    .then(function (logoutUrl) {
                        erateSessionVarsService.setProviderLogoutUrl(logoutUrl);
                        return providerFeaturesService.getProviderApplicationSetting('ShowcaseLiteIntro', 'false');
                    })
                    .then(function (showcaseIntro) {
                        showcaseIntroVal = showcaseIntro;
                        //get the user by id
                        return identityMgmntService.getUserById(imUserId);
                    })
                    .then(
                    function (imUser) {
                        //set the user for the session

                        var promiseCalls = [];
                        //here is where we set the auth token to the TRUE user's identity::
                        var setupSSOUserP = ssoAuthenticationService.setupSSOUser(imUser);
                        //provider
                        var getProviderP = identityMgmntService.getProviderByProviderId(imProviderId);
                        //dealership
                        var getDealerP = identityMgmntService.getDealerById(imDealerId);
                        //roles
                        var getRolesP = rolePermissionsService.generateUserRoleRouteMap();

                        $q.all([setupSSOUserP, getProviderP, getDealerP, getRolesP])
                            .then(
                            function (promiseReturns) {
                                //aren't using [0] promise return

                                var imProvider = promiseReturns[1];
                                imSessionVarsService.setCurrentProviderCode(imProvider.ProviderCode);

                                var imDealer = promiseReturns[2];

                                var dealerInfo = new DealerInfo();
                                dealerInfo.populateDataFromIdentityManagement(imDealer);
                                if (!dealerInfo.accountCode) {
                                    throw new TLCError(new Error('Could not find dealer account code for integrated dealer: ' + imDealerId), AppErrorCodes.SSOIntegrationController_GeneralError);
                                }
                                try {
                                    commonTLCService.setupEssentialDealerVars(dealerInfo)
                                        .then(function () {
                                            //clear out any "stale" state information
                                            rateQuoteCoordService.startNewQuoteSession(true, true, true, true);
                                            imSessionVarsService.setCurrentIMUser(imUser);
                                            imSessionVarsService.setCurrentIMUserRoles(imUser.Claims);

                                            //if we sso in, we need to set up chat info now that we are in quote creation
                                            var provcode = imSessionVarsService.getCurrentProviderCode();

                                            if ((showcaseIntroVal || 'false').toUpperCase() == 'TRUE')
                                                $location.url(routes.showcaseLiteRedirect);
                                            else
                                                $location.url(routes.createQuote);
                                        }),
                                        function (err) {
                                            // This should never happen
                                            // Todo: do something with this error. Currently, it is just being thrown as an exception that gets lost.
                                            throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                                        }
                                }
                                catch (ex) {
                                    // This should not happen
                                    switch (ex) {
                                        case "ACCOUNT-NOT-FOUND":
                                            throw new TLCError(new Error('Could not find dealer account code for dealer: ' + dealerInfo.name), AppErrorCodes.SSOIntegrationController_GeneralError);
                                        case "SPANID-NOT-FOUND":
                                            throw new TLCError(new Error('Could not find dealer SPAN id for  dealer: ' + dealerInfo.name), AppErrorCodes.SSOIntegrationController_GeneralError);
                                    }
                                    throw new TLCError(new Error(ex), AppErrorCodes.SSOIntegrationController_GeneralError);
                                }                    //set the dealership's account code
                            })
                            .catch(function (err) {
                                throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                            });
                    },
                    function (err) {
                        throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                    }
                    );
            }

            var userAndDealerSSOIm = function (imssoToken, imssoDealerId, ssoShCaseView) {
                var imDealerId = imssoDealerId;
                var imProviderId = null;
                var imUserId = null;
                var spanDealerId = null;
                var showcaseIntroVal = null;

                var referrer = document.referrer;
                if (referrer){
                    referrer = referrer.replace('home','login');
                }
                //impersonate the "global authorized user" until we get the user's data
                userAuthenticateService.setUserToken(imssoToken);

                userAuthenticateService.GetClaimInfo()
                .then(
                    function (claimInfo){
                        imUserId = claimInfo.UserId;

                        return identityMgmntService.getUserById(imUserId);
                    },
                    function (err) {
                        throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                    }
                )
                .then(
                    function (loggedInUsr){
                        imProviderId = loggedInUsr.PrimaryProviderId;

                        return identityMgmntService.getDealerById(imDealerId);
                    },
                    function (err) {
                        throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                    }
                )
                .then(
                    function (imDealership){
                        var spanLink = _.find(imDealership.LegacyLinks, function(lnk){return lnk.LegacyApplication=="SPAN"})
                        if (spanLink == null)
                            throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                        spanDealerId = spanLink.LegacyTableId;
                        return commonTLCService.encryptNumeric(spanDealerId);
                    },
                    function (err) {
                        throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                    }
                )
                .then(function (encid) {
                    erateSessionVarsService.setCurrentDealerSPANId(encid);
                    imSessionVarsService.setCurrentProviderId(imProviderId);
                    imSessionVarsService.setCurrentDealerIMId(imDealerId);
                    return providerFeaturesService.getProviderApplicationSetting('LogoutRedirectUrl', null);
                })
                .then(function (logoutUrl) {
                    erateSessionVarsService.setProviderLogoutUrl(logoutUrl);
                    return providerFeaturesService.getProviderApplicationSetting('ShowcaseLiteIntro', 'false');
                })
                .then(function (showcaseIntro) {
                    showcaseIntroVal = showcaseIntro;
                    //get the user by id
                    return identityMgmntService.getUserById(imUserId);
                })
                .then(
                    function (imUser) {
                    //set the user for the session

                    usageEventsService.userChanges(imUser);

                    var promiseCalls = [];
                    //here is where we set the auth token to the TRUE user's identity::
                    var setupSSOUserP = ssoAuthenticationService.setupSSOUser(imUser);
                    //provider
                    var getProviderP = identityMgmntService.getProviderByProviderId(imProviderId);
                    //dealership
                    var getDealerP = identityMgmntService.getDealerById(imDealerId);
                    //roles
                    var getRolesP = rolePermissionsService.generateUserRoleRouteMap();

                    $q.all([setupSSOUserP, getProviderP, getDealerP, getRolesP])
                        .then(
                        function (promiseReturns) {
                            //aren't using [0] promise return

                            var imProvider = promiseReturns[1];
                            imSessionVarsService.setCurrentProviderCode(imProvider.ProviderCode);

                            var imDealer = promiseReturns[2];

                            var dealerInfo = new DealerInfo();
                            dealerInfo.populateDataFromIdentityManagement(imDealer);
                            if (!dealerInfo.accountCode) {
                                throw new TLCError(new Error('Could not find dealer account code for integrated dealer: ' + imDealerId), AppErrorCodes.SSOIntegrationController_GeneralError);
                            }
                            try {
                                usageEventsService.dealerChanges(imDealer.Id);

                                commonTLCService.setupEssentialDealerVars(dealerInfo)
                                    .then(function () {
                                        //clear out any "stale" state information
                                        rateQuoteCoordService.startNewQuoteSession(true, true, true, true);
                                        imSessionVarsService.setCurrentIMUser(imUser);
                                        imSessionVarsService.setCurrentIMUserRoles(imUser.Claims);
                                        //if we sso in, we need to set up chat info now that we are in quote creation
                                        var provcode = imSessionVarsService.getCurrentProviderCode();
                                        if (ssoShCaseView) {
                                            switch (ssoShCaseView.toUpperCase()) {
                                                case 'SETTINGS':
                                                    imSessionVarsService.setShowcaseIntegrated(true);
                                                    $location.url(routes.dealerSettings);
                                                    break;
                                                case 'CONTRACTACTIVITY':
                                                    imSessionVarsService.setShowcaseIntegrated(true);
                                                    $location.url(routes.remitRegister);
                                                    break;
                                                case 'ADDLENDER':
                                                    imSessionVarsService.setShowcaseIntegrated(true);
                                                    imSessionVarsService.setShowcaseIntegratedSetting('Lenders');
                                                    $location.url(routes.dealerSettings);
                                                    break;
                                                default:
                                                    if ((showcaseIntroVal || 'false').toUpperCase() == 'true')
                                                        $location.url(routes.showcaseLiteRedirect);
                                                    else
                                                        $location.url(routes.createQuote);
                                            }
                                        }
                                        else
                                            $location.url(routes.createQuote);
                                    }),
                                    function (err) {
                                        // This should never happen
                                        // Todo: do something with this error. Currently, it is just being thrown as an exception that gets lost.
                                        throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                                    }
                            }
                            catch (ex) {
                                // This should not happen
                                switch (ex) {
                                    case "ACCOUNT-NOT-FOUND":
                                        throw new TLCError(new Error('Could not find dealer account code for dealer: ' + dealerInfo.name), AppErrorCodes.SSOIntegrationController_GeneralError);
                                    case "SPANID-NOT-FOUND":
                                        throw new TLCError(new Error('Could not find dealer SPAN id for  dealer: ' + dealerInfo.name), AppErrorCodes.SSOIntegrationController_GeneralError);
                                }
                                throw new TLCError(new Error(ex), AppErrorCodes.SSOIntegrationController_GeneralError);
                            }                    //set the dealership's account code
                        })
                        .catch(function (err) {
                            throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                        });
                },
                function (err) {
                    throw new TLCError(new Error(err), AppErrorCodes.SSOIntegrationController_GeneralError);
                }
                );
            }
        }]);
